
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { EmployeeFormData } from "@/types/employee";

interface AdditionalInfoSectionProps {
  formData: EmployeeFormData;
  setFormData: (data: EmployeeFormData) => void;
}

export const AdditionalInfoSection = ({ formData, setFormData }: AdditionalInfoSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">معلومات إضافية</h3>
      <div className="space-y-2">
        <Label htmlFor="qualifications">المؤهلات</Label>
        <Textarea
          id="qualifications"
          value={formData.qualifications}
          onChange={(e) => setFormData({...formData, qualifications: e.target.value})}
          rows={2}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="previous_experience">الخبرة السابقة</Label>
        <Textarea
          id="previous_experience"
          value={formData.previous_experience}
          onChange={(e) => setFormData({...formData, previous_experience: e.target.value})}
          rows={2}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="electronic_accounts">الحسابات الإلكترونية (JSON)</Label>
        <Textarea
          id="electronic_accounts"
          value={formData.electronic_accounts}
          onChange={(e) => setFormData({...formData, electronic_accounts: e.target.value})}
          placeholder='{"twitter": "@username", "linkedin": "profile-url"}'
          rows={2}
        />
      </div>
    </div>
  );
};
